import React from "react";

export default function ListFilterActions({
  showExport = false,
  onExport,
  showReset = false,
  onReset,
  exportLabel = "Download Excel",
}) {
  if (!showExport && !showReset) {
    return null;
  }

  return (
    <div className="cms-filter-actions d-inline-flex align-items-center gap-2 flex-shrink-0">
      {showExport && (
        <button type="button" className="btn btn-sm btn-primary cms-list-btn" onClick={onExport}>
          <i className="ri-file-excel-2-line me-1" />
          {exportLabel}
        </button>
      )}
      {showReset && (
        <button type="button" className="btn btn-sm btn-outline-primary cms-list-btn" onClick={onReset}>
          <i className="ri-restart-line me-1" />
          Reset
        </button>
      )}
    </div>
  );
}
